/* eslint-disable @typescript-eslint/no-explicit-any */
import { api } from "../api";

export interface LoginCredentials {
  documento: string;
  senha: string;
  notificationToken?: string;
}

export interface User {
  id: number;
  nome: string;
  documento: string;
  email: string;
  telefone?: string;
  publicId: string;
  type: "tutor" | "ong";
  isEmailVerified: boolean;
}

export interface LoginResponse {
  token: string;
  user: User;
}

export class LoginService {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    try {
      const response = await api.post<LoginResponse>("/login", credentials);
      return response.data;
    } catch (error: any) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error("Erro ao fazer login. Tente novamente.");
    }
  }

  async getUser(token: string): Promise<User> {
    try {
      const response = await api.get<User>("/me", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error: any) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error("Erro ao buscar dados do usuário.");
    }
  }
}